<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import Select from "@/components/c-select";
import Loading from "@/components/c-loading";

// import i18n from "../../../../i18n";
import { templateService } from "../../../../services/saleservice/template.service";
import { contracttypeService } from "../../../../services/settingservice/contracttype.service";

/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Property Change Payment Term",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading,
    Button,
    Input,
    Select,
    // ckeditor: CKEditor.component,
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "property",
      breadCrumb: {},
      // editor: ClassicEditor,
      editorData: '',
      editorConfig: {
          height: '800px'
      },
      template: {},
      contractType: {},
      contractTypesList: {},

      dataName: '',
      dataType: 0,
      dataPath: '',
      dataConent: '<h2 style="color: #339966;">Hi there from TinyMCE for Vue.js.</h2> <p>&nbsp;</p> <p><span>Hey y`all.</span></p>',

      plugins: [
        "advlist autolink link image lists charmap print preview hr anchor pagebreak spellchecker",
        "searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking",
        "save table contextmenu directionality emoticons template paste textcolor",
      ],
      toolbar:
        "insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | l      ink image | print preview media fullpage | forecolor backcolor emoticons",
      options: {
        height: 650,
        style_formats: [
          { title: "Bold text", inline: "b" },
          { title: "Red text", inline: "span", styles: { color: "#ff0000" } },
          { title: "Red header", block: "h1", styles: { color: "#ff0000" } },
          { title: "Example 1", inline: "span", classes: "example1" },
          { title: "Example 2", inline: "span", classes: "example2" },
          { title: "Table styles" },
          { title: "Table row 1", selector: "tr", classes: "tablerow1" },
        ],
      },

    };
  },
  mounted() {

    this.loadingContractTypeData();
    
    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);     

    } 
  },

  methods: {

    loadingData: function(id) {
      this.fetchingStats = false;
      templateService.getOne(id)
        .then(response => {
          
          this.fetchingStats = true;
          this.template = response.data;

          this.dataName = this.template.name;
          this.dataType = this.template.contract_type_id;
          this.dataPath = this.template.path;
          // this.dataConent = this.template.content;

          ///img/h-logo.20e8cce7.svg
          //@/assets/images/3symbol.svg

          // console.log(JSON.stringify( response.data));
        });
    },

    loadingContractTypeData: function() {
      contracttypeService.getList()
        .then(response => {
          this.contractTypesList = response;

        });
    },

    submitSave: function() {
      
      this.tryingToSubmit = true;

      // scheduleService.change({
      //   schedule_id: this.selectedSchedule,
      //   schedules: this.dataSchedule
        
      // }).then(response => {
      //   if(response.status == 200) {
          
      //     this.$swal.fire({
      //       title: i18n.t('general.success.title'),
      //       text: i18n.t('general.success.message'),
      //       icon: "success",
      //       showCancelButton: true,
      //       confirmButtonColor: "#34c38f",
      //       cancelButtonColor: "#f46a6a",
      //       confirmButtonText: i18n.t('general.success.yes'),
      //       cancelButtonText: i18n.t('general.success.no')
      //     }).then(result => {
      //       if (!result.value) {
      //         this.$router.push(this.$route.query.redirectFrom || {
      //           name: "sale-list"
      //         });
      //       } 
      //     });

      //   }
      // });

    }

  }
};
</script>

<template>
  <Layout>
    <!-- <PageHeader :items="['']" :title="$t('setting.configuration.contract-template.text')" /> -->
    <div v-if="this.isAdd">
      <PageHeader :items="[{
        text: $t('setting.configuration.contract-template.text'),
        href: '/setting/contract',
      }, {
        text: $t('setting.configuration.contract-template.new'),
        active: true
      }]" :title="this.isAdd ? $t('setting.configuration.contract-template.new') : $t('setting.configuration.contract-template.edit')" />
    </div>
    <div v-else>
      <PageHeader :items="[{
        text: $t('setting.configuration.contract-template.text'),
        href: '/setting/contract',
      }, this.breadCrumb]" :title="this.isAdd ? $t('setting.configuration.contract-template.new') : $t('setting.configuration.contract-template.edit')" />
    </div>
    <Loading :loaded="fetchingStats" />


    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-sm-9">
        <div class="card">
          <div class="card-body">
              <!-- <label class="input-group-text" :for="'content'">{{$t('setting.configuration.contract-template.content')}}</label> -->
              <!-- <ckeditor :id="'content'" v-model="dataConent" :editor="editor" :config="editorConfig"></ckeditor> -->
              <!-- <tinymce
                  id="content"
                  v-model="dataConent"
                  :plugins="plugins"
                  :toolbar="toolbar"
                  :other_options="options"
                ></tinymce> -->
              <tinymce id="d1" 
                      :other_options="tinyOptions" 
                      v-model="editorContent"
              ></tinymce>
              <div class="row" style="height: 15px;"></div>
          
          </div>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="card">
          <div class="card-body">
            
            <div class="row">
              <div class="col-md-12">
                 <Select 
                    :id="'contract_type_id'"
                    :text="'name'"
                    :text2="'name_en'"
                    :required="true"
                    v-model="dataType"
                    :list="this.contractTypesList"
                    :label="'setting.configuration.contract-template.type'"  />
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                 <Input 
                    :type="'text'"
                    :id="'name'"
                    v-model="dataName"
                    :label="'setting.configuration.contract-template.name'"  />
              </div>
            </div>

             <div class="row">
              <div class="col-md-12">
                 <Input 
                    :type="'text'"
                    :id="'path'"
                    v-model="dataPath"
                    :label="'setting.configuration.contract-template.path'"  />
              </div>
            </div>

          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                 <Button v-bind:icon="'bx bx-x-circle'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'danger'"
                        @click="submitCancel()"
                        v-bind:title="$t('general.cancel')"  />
              </div>
              <div class="col-md-6">
                 <Button v-bind:icon="'bx bx-save bx-tada'" 
                        v-bind:buttonType="'button'"
                        @click="submitSave()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.save')"  />
              </div>
            </div>

          </div>
        </div>

      </div>
    </b-form> 

  </Layout>
</template>